export default __webpack_public_path__ + "static/media/trash-2.bba7f8a9.svg";